import type { IconData } from '@stacksjs/iconify-core'

export const starHalfF: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M9.989 0L10 .024V15.76l-.011-.006L3.815 19l1.179-6.874L0 7.257l6.902-1.003z\"/>",
  "width": 10,
  "height": 19,
  "viewBox": "0 0 10 19"
}

export default starHalfF
